import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { useLanguage } from '../../context/LanguageContext';
import { i18n } from '../../i18n/i18n';
import { KidCard } from '../kid/KidUI';
import { FEATURES } from '../../constants/features';
import { billingBanner } from '../../utils/billing';
import { formatDeletionDate } from '../../utils/accountDeletion';

/** Home, admins only: trial ending soon / a failed payment / a cancellation (payments groundwork). */
const BillingBanner: React.FC = () => {
  const { current_family, current_user } = useAppContext() as any;
  const { current_language } = useLanguage();
  const billing = current_family?.billing;
  const kind = billingBanner(billing, !!current_user?.is_admin, FEATURES.payments);
  if (!kind) return null;
  const date = (iso: string | null) => (iso ? formatDeletionDate(iso, current_language) : '');
  const text = kind === 'trial_ending'
    ? i18n.t(billing.trialDaysLeft === 0 ? 'billing.banner_trial_last_day' : 'billing.banner_trial').replace('{{days}}', String(billing.trialDaysLeft))
    : kind === 'payment_problem'
      ? i18n.t('billing.banner_payment').replace('{{date}}', date(billing.until))
      : i18n.t('billing.banner_cancelling').replace('{{date}}', date(billing.until));
  return (
    <KidCard tone="peach" className="mb-5 flex flex-wrap items-center justify-between gap-3 !py-3">
      <span className="text-base font-bold">{text}</span>
      <Link to="/subscription" className="min-h-[44px] inline-flex items-center rounded-full px-5 bg-kid-card dark:bg-kid-card-dark border-2 border-kid-border-strong font-bold">
        {i18n.t('billing.banner_action')}
      </Link>
    </KidCard>
  );
};

export default BillingBanner;
